<mat-card
  *ngIf="
    (activeUserError$ | async) === false &&
    (activeUserLoading$ | async) === false
  "
>
  <form
    [formGroup]="form"
    appScrollToInvalidControl
    [appEditableWithRole]="['USER_ADMIN']"
  >
    <div class="input">
      <p>{{ "ADMINS.TITLE.FIRST_NAME" | translate }}</p>
      <mat-form-field appearance="outline">
        <input
          matInput
          [placeholder]="'ADMINS.PLACEHOLDER.FIRST_NAME' | translate"
          formControlName="firstName"
        />
        <mat-hint>{{ "ADMINS.HINT.REQUIRED" | translate }}</mat-hint>
      </mat-form-field>
    </div>
    <br />
    <div class="input">
      <p>{{ "ADMINS.TITLE.LAST_NAME" | translate }}</p>
      <mat-form-field appearance="outline">
        <input
          matInput
          [placeholder]="'ADMINS.PLACEHOLDER.LAST_NAME' | translate"
          formControlName="lastName"
        />
        <mat-hint>{{ "ADMINS.HINT.REQUIRED" | translate }}</mat-hint>
      </mat-form-field>
    </div>
    <br />
    <div class="input">
      <p>{{ "ADMINS.TITLE.EMAIL" | translate }}</p>
      <mat-form-field appearance="outline">
        <input
          matInput
          [placeholder]="'ADMINS.PLACEHOLDER.EMAIL' | translate"
          formControlName="email"
          readonly
        />
      </mat-form-field>
    </div>
    <br />
    <div class="input">
      <p>{{ "ADMINS.TITLE.PHONE" | translate }}</p>
      <app-phone-subform
        class="w-100"
        controlName="phoneNumber"
        placeholder="ADMINS.PLACEHOLDER.PHONE"
        hint="ADMINS.HINT.PHONE"
      ></app-phone-subform>
    </div>
    <br />
    <div class="input">
      <p>{{ "ADMINS.TITLE.ROLES" | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="roles"
          multiple
          [placeholder]="'ADMINS.PLACEHOLDER.ROLES' | translate"
        >
          <mat-option
            *ngFor="let role of roleList"
            [value]="role"
            [disabled]="isRoleDisabled(role)"
          >
            {{ "ADMINS.ROLES." + role | translate }}
          </mat-option>
        </mat-select>
        <mat-hint>{{ "ADMINS.HINT.REQUIRED" | translate }}</mat-hint>
        <mat-error *ngIf="getServerError('roles')">
          {{ getServerError("roles") }}
        </mat-error>
      </mat-form-field>
    </div>
    <br />
    <div class="button-row">
      <button
        type="button"
        mat-stroked-button
        color="primary"
        [routerLink]="'/account/users'"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ "ADMINS.BTN.BACK" | translate | uppercase }}
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        class="submit"
      >
        {{ "ADMINS.BTN.EDIT" | translate | uppercase }}
      </button>
    </div>
  </form>
</mat-card>
